import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  SearchRequest,
  SimpleNavigation,
  SimpleRefinementItem,
} from '@usf/product-types';
import { FilterRequestModel } from 'src/app/search/shared/models/filter-request-model';
import { RangeRefinementItem } from 'src/app/search/shared/models/range-refinement-item-model';
import { PlatformService } from '@panamax/app-state';
import { SearchFilterSelected } from '@search/shared/models/search-filter-selected';

@Component({
  selector: 'app-range-refinement-menu',
  templateUrl: './range-refinement-menu.component.html',
  styleUrls: ['./range-refinement-menu.component.scss'],
})
export class RangeRefinementMenuComponent implements OnInit, OnChanges {
  @Input() filterNav: SimpleNavigation;
  @Input() searchRequest: SearchRequest;
  @Output()
  selectRangeFilterOption: EventEmitter<FilterRequestModel> = new EventEmitter();
  rangeRefinements: RangeRefinementItem[];
  timer: any;

  constructor(readonly platformService: PlatformService) {}

  ngOnInit() {
    this.rangeRefinements = this.filterNav?.rangeRefinements?.map(
      (r: SimpleRefinementItem) =>
        ({
          ...r,
          displayName: this.extractDisplayNameAndUOM(r.displayName)[0],
          uom: this.extractDisplayNameAndUOM(r.displayName)[1],
        } as RangeRefinementItem),
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.product?.currentValue) {
      this.rangeRefinements = this.filterNav?.rangeRefinements?.map(
        (r: SimpleRefinementItem) =>
          ({
            ...r,
            displayName: this.extractDisplayNameAndUOM(r.displayName)[0],
            uom: this.extractDisplayNameAndUOM(r.displayName)[1],
          } as RangeRefinementItem),
      );
    }
  }

  extractDisplayNameAndUOM = (s: string): string[] => {
    const parts: string[] = s.split('(');
    const displayName = parts[0];
    const uom = parts[1]?.substring(0, parts[1]?.indexOf(')')) || 'kcal';
    return [displayName, uom];
  };

  changeRangeValue(
    range: SimpleRefinementItem,
    minVal?: string,
    maxVal?: string,
  ) {
    //Calories|BTWN%202%2029||Carbohydrates|BTWN%202%203
    const minValue = Number(minVal);
    const maxValue = Number(maxVal);
    if (
      (minValue < 0 || minValue > 999 || isNaN(minValue)) &&
      (maxValue < 0 || maxValue > 999 || isNaN(maxValue))
    ) {
      return;
    }
    range = { ...range, minVal, maxVal };

    let rangeRefinements = `${range.dimesionName}|BTWN ${range.minVal} ${range.maxVal}`;
    if (!minVal) {
      rangeRefinements = `${range.dimesionName}|LTEQ ${range.maxVal}`;
    } else if (!maxVal) {
      rangeRefinements = `${range.dimesionName}|GTEQ ${range.minVal}`;
    }
    const currentRanges: string[] = this.searchRequest?.rangeRefinements
      ?.split('||')
      ?.filter(r => r.split('|')[0] !== range.dimesionName);
    if (currentRanges?.length > 0) {
      rangeRefinements =
        currentRanges.reduce((a, b) => a + '||' + b) + '||' + rangeRefinements;
    }
    this.searchRequest = { ...this.searchRequest, rangeRefinements };
    if (this.timer) {
      clearTimeout(this.timer);
    }
    const searchFilterSelected: SearchFilterSelected = {
      filterNav: this.filterNav,
      refinementItem: range,
    };
    this.timer = setTimeout(() => {
      this.selectRangeFilterOption.emit({
        ...this.searchRequest,
        rangeSelectedFilter: this.filterNav.displayName,
        searchFilterSelected,
      });
    }, 1000);
  }

  resetAllRanges() {
    const rangeRefinements = null;
    this.searchRequest = { ...this.searchRequest, rangeRefinements };
    this.selectRangeFilterOption.emit({
      ...this.searchRequest,
      rangeSelectedFilter: null,
    });
  }
}
